module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/097-san-marino-e83b6d2a1080a60055f856c83d36cd3f.svg";